import React, { useState, useEffect } from "react";
import styles from "./PriceDetailComponent.module.css";
import CustomInput from "@components/CustomInput/CustomInput";
import Button from "@components/Button";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { notify } from "src/utils/notify";
import usePopup from "@hooks/usePopup";
import ConfirmDetailsPopup from "@components/ConfirmDetailsPopup/ConfirmDetailsPopup";
import DetailTableComponent from "@components/DetailTableComponent/DetailTableComponent";
import useWindowSize from "@hooks/useWindowSize";
import { useNavigate } from "react-router";
import usePrice from "@hooks/usePrice";
import { Home } from "@mui/icons-material";

const PriceDetailComponent = ({ priceData }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [rows, setRows] = useState([]);
  const [priceArray, setPriceArray] = useState([]);
  const [editedPriceDetails, setEditedPriceDetails] = useState({});
  console.log("editedPriceDetails", editedPriceDetails);
  const { width } = useWindowSize();
  const navigate = useNavigate();
  const { handleUpdatePrice } = usePrice();
  const { handlePopupCenterOpen, handlePopupCenterComponentRender } = usePopup();

  const fieldNameMappings = {
     "My Reference Number":"myReferenceNumber",
     "Registered Email":"registeredEmail",
     "Contact":"contact",
     "First Name":"firstName",
     "Institute Name":"instituteName",
     "Pincode":"pincode",
     "Price 01":"Quarterly",
     "Price 02":"Half yearly",
     "Price 03":"Annual",
     "Added by":"addedBy",
     "Created At" : "createdAt",
     "Updated At" : "updatedAt",

  }

  const getFieldName = (name) => fieldNameMappings[name] || name;

  const handleCopy = (copiedText) => {
    if (typeof copiedText === "object") {
      navigator.clipboard.writeText(JSON.stringify(copiedText?.props?.data));
      notify("Copied to clipboard", "success");
    } else {
      navigator.clipboard.writeText(copiedText);
      notify("Copied to clipboard", "success");
    }
  };

  function createData(name, code) {
    return {
      name,
      code,
      copy: (
        <ContentCopyIcon
          sx={{ cursor: "pointer" }}
          onClick={() => handleCopy(code)}
        />
      )
    };
  }

  function formatDateTime(item){
    return new Date(item).toLocaleString();
  }

  const extractPriceDetails = (price) => {
    const obj = {
      myReferenceNumber: price.myReferenceNumber,
      registeredEmail: price.registeredEmail,
      contact: price.contact,
      firstName: price.firstName,
      instituteName: price.instituteName,
      pincode: price.pincode,
      quarterly: price.settledPrice.OY0240003,
      halfyearly: price.settledPrice.OY0240006,
      annually: price.settledPrice.OY0240012,
      addedBy: price.addedBy,
      createdAt: formatDateTime(price.created_at),
      updatedAt: formatDateTime(price.updated_at),
    };
    const formattedArray = Object.entries(obj).map(([key, value]) => ({
      name: key,
      code: value,
    }));

    return formattedArray;
  }

  const handleInputChange = ({ target }) => {
    const { name, value } = target;
    console.log("name", name, "value", value);
    setEditedPriceDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const isReactComponent = (obj) => React.isValidElement(obj);

  useEffect(() => {
    const updatedRows = isEditing ?
      priceArray.map(({ name, code }) => {
        if (
          name === "myReferenceNumber" ||
          name === "registeredEmail" ||
          name === "addedBy" ||
          name === "contact" ||
          name === "firstName" ||
          name === "instituteName" ||
          name === "pincode" ||
          name === "createdAt" ||
          name === "updatedAt" || 
          name === "created_at" ||
          name === "updated_at"
          
        ) {
          return createData(name, code);
        } else {
          return createData(
            name,
            <CustomInput
              value={
                editedPriceDetails[getFieldName(name)] !== undefined
                  ? editedPriceDetails[getFieldName(name)]
                  : isReactComponent(code)
                    ? code.props.data
                    : code
              }
              name={getFieldName(name)}
              onChange={(event) => {handleInputChange(event)}}
            />
          );
        }

      })
      : priceArray?.map(({ name, code }) => {
        return createData(name, code)
      });

    setRows(updatedRows);
  }, [isEditing, editedPriceDetails, priceArray]);

  useEffect(() => {
    if (priceData) {
      const formattedArray = extractPriceDetails(priceData);
      setPriceArray(formattedArray);
    }
  }, [priceData]);


  const columns = [
    { id: "name", label: "Name", minWidth: 170 },
    { id: "code", label: "Value", minWidth: 170 },
    { id: "copy", label: "Copy", minWidth: 170 },

  ];

  const handleEdit = () => {
    setIsEditing(true);
  }

  const onSuccess = () => {
    setEditedPriceDetails({});
  }

  const handleOnConfirm = () => {
    const updatedPriceDetails = {
      settledPrice: {
        OY0240003: editedPriceDetails?.quarterly ?? priceData?.settledPrice?.OY0240003 ?? "",
        OY0240006: editedPriceDetails?.halfyearly ?? priceData?.settledPrice?.OY0240006 ?? "",
        OY0240012: editedPriceDetails?.annually ?? priceData?.settledPrice?.OY0240012 ?? "",
      },
      myReferenceNumber: editedPriceDetails?.myReferenceNumber ?? priceData?.myReferenceNumber ?? "",
      registeredEmail: editedPriceDetails?.registeredEmail ?? priceData?.registeredEmail ?? "",
      contact: editedPriceDetails?.contact ?? priceData?.contact ?? "",
      firstName: editedPriceDetails?.firstName ?? priceData?.firstName ?? "",
      instituteName: editedPriceDetails?.instituteName ?? priceData?.instituteName ?? "",
      pincode: editedPriceDetails?.pincode ?? priceData?.pincode ?? "",
      addedBy: editedPriceDetails?.addedBy ?? priceData?.addedBy ?? "",
      doctorId: priceData?.doctorId ?? "",
    };
  
    handleUpdatePrice(priceData?._id, updatedPriceDetails, onSuccess);
    handlePopupCenterOpen(false);
  };
  

  const handleCancelConfirm = () => {
    handlePopupCenterOpen(false);
    setEditedPriceDetails({});
  }

  const handleSave = () => {
    setIsEditing(false);
    handlePopupCenterOpen(true);
    handlePopupCenterComponentRender(
      <ConfirmDetailsPopup
        details={editedPriceDetails}
        onConfirm={handleOnConfirm}
        onCancel={handleCancelConfirm}
      />
    );
  }

  const handleNavigateDashboard = () => {
    navigate("/");
  }

  const handleEditCancel = () => {
    setIsEditing(false);
    setEditedPriceDetails({});
  }

  const handleNavigatePrice = () => {
    navigate('/manageprice')
  };

  const convertArrayToCSV = (data) => {
    const csvRows = [];
    // Get the headers
    const headers = Object.keys(data[0]);
    csvRows.push(headers.join(","));

    // Loop over the rows
    for (const row of data) {
      const values = headers.map((header) => {
        const value = row[header];
        let escaped;
        if (typeof value === "object" && value !== null) {
          escaped = JSON.stringify(value?.props?.data);
        } else {
          escaped = ("" + value).replace(/"/g, '\\"');
        }
        return `"${escaped}"`;
      });
      csvRows.push(values.join(","));
    }

    return csvRows.join("\n");
  };

  const downloadCSV = () => {
    const csvData = convertArrayToCSV(priceArray);
    const blob = new Blob([csvData], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("hidden", "");
    a.setAttribute("href", url);
    a.setAttribute("download", `price_${priceData?.myReferenceNumber}.csv`);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };



  return (
    <div className={styles.Wrapper}>
      <div className={styles.BreadCrumb}>
        <div className={styles.NavigationWrapper}>
          <Home className={styles.HomeIcon} onClick={handleNavigateDashboard} />{" "}
          <div>
            <span
              className={styles.DashboardText}
              onClick={handleNavigateDashboard}
            >
              Dashboard
            </span>
            <span
              className={`${styles.RouteText} ${styles.CursorPointer}`}
              onClick={handleNavigatePrice}
            >
              {" "}
              /Price
            </span>
            <span className={styles.RouteText}> /{priceData?._id}</span>
          </div>
        </div>
        <div className={styles.BtnWrapper}>
          {width > 600 ? (
            <Button
              text={"Export to CSV"}
              btnType={"secondary"}
              onClick={downloadCSV}
            />
          ) : null}
          {isEditing ? (
            <>
              <Button btnType={"primary"} text={"Save"} onClick={handleSave} />
              <Button
                btnType={"secondary"}
                text={"Cancel"}
                onClick={handleEditCancel}
              />
            </>
          ) : (
            <Button btnType={"secondary"} text={"Edit"} onClick={handleEdit} />
          )}
        </div>
      </div>
      <DetailTableComponent rows={rows} columns={columns} />
      {width > 600 ? null : (
        <Button
          text={"Export to CSV"}
          btnType={"secondary"}
          onClick={downloadCSV}
          className={styles.ExportCsvBtn}
        />
      )}
    </div>
  );
};

export default PriceDetailComponent;
